import { useQuery } from '@tanstack/react-query';
import { ParkingBillingSetting } from '../models/parkingBillingSetting.ts';
import { fetchParkingBillingSettings } from '../api/parking-billing-setting.ts';

export default function useParkingBillingSettings() {
  const queryFn = fetchParkingBillingSettings;
  return useQuery<ParkingBillingSetting[]>({
    queryKey: ['parkingBillingSettings'],
    queryFn,
  });
}
